// @ts-nocheck

import React from 'react';

import { __ } from '../../i18n/l10n';
import AlertDialog from '../../wx/components/alert-dialog';

const Review = ({ closeDialog, disable, isDialogOpen, rate }: unknown) => {
  const BUTTONS = [
    { label: __('No'), handler: disable },
    { label: __('Later'), handler: closeDialog },
    { label: __('Yes'), handler: rate, isDefault: true },
  ];

  return (
    <AlertDialog
      isOpen={isDialogOpen}
      isCancelable
      onCancel={closeDialog}
      title={__('Do you like this application?')}
      content={__('Do you wish to comment on this application?')}
      buttons={BUTTONS}
      isColumn
    />
  );
};

export default Review;
